export function formatClipsFromSporty(clips) {
  return clips.map(clip => {
    return {
      ...clip,
      playIds: clip.plays.map(play => play.playId),
      name: clip.title,
      videoId: clip.id,
      url: clip.videoUri,
      commonClipSearchMetadata: { category: clip.searchCategory },
      durationInSeconds: Number(clip.duration)
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/format.js